import {AfterViewInit, Component, OnInit} from '@angular/core';
import {ActivatedRoute} from '@angular/router';

@Component({
  selector: 'app-homepage',
  templateUrl: './homepage.component.html',
  styleUrls: ['./homepage.component.css']
})
export class HomepageComponent implements OnInit, AfterViewInit {
  public fragment: string;

  constructor(private route: ActivatedRoute) {
  }

  public ngOnInit() {
    this.route.fragment.subscribe((fragment) => {
      this.fragment = fragment;
    });
  }

  /**
   * Go to anchor
   * @param {string} value
   */
  public goToConsultation = (value: string) => {

    try {
      document.querySelector('#' + value).scrollIntoView();
      // now account for fixed header
      const scrolledY = window.scrollY;
      const yourHeight = 93;
      if (scrolledY) {
        window.scroll(0, (scrolledY - yourHeight) - 250);
      }
    } catch (e) {
      console.log(e);
    }
  }

  public ngAfterViewInit(): void {
    try {
      document.querySelector('#' + this.fragment).scrollIntoView();
      // now account for fixed header
      const scrolledY = window.scrollY;
      const yourHeight = 93;
      if (scrolledY) {
        window.scroll(0, (scrolledY - yourHeight) - 250);
      }
    } catch (e) {
      console.log(e);
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/components/homepage/homepage.component.ts